/** TODO-themes: replace theme names ('purple', 'orange', etc.) with correct ones if needed.
 * These are theme names that will come in backend response.
 * We need to wait until backend will be ready and a contract will be established.
 * Backend ticket number: SUR-3463
 */
export enum THEME_NAME {
  PURPLE = 'purple',
  ORANGE = 'orange',
  BLUE = 'blue',
  BLUE_DARK = 'darkBlue',
  GREEN = 'green',
  TURQUOISE = 'turquoise',
}

export type ColorVariables = {
  [key: string]: string;
};

export type ThemeColorSet = {
  primary: string;
  primary_rgb: string;
  primaryDark: string;
  primaryLight: string;
  primaryLight2: string;
  primaryLight3: string;
};

export type ThemesColors = {
  [key in THEME_NAME]: ThemeColorSet;
};

export const DEFAULT_THEME = THEME_NAME.PURPLE;

export const THEME_CLASSNAME_SUFFIX = '-theme';
